// This file is auto-generated by @hey-api/openapi-ts

import {
  createClient,
  createConfig,
  type Options,
} from "@hey-api/client-fetch";
import type {
  AcceptOfferData,
  AcceptOfferError,
  AcceptOfferResponse,
  AddFormSchoolTagData,
  AddFormSchoolTagError,
  AddFormSchoolTagResponse,
  AddFormTagData,
  AddFormTagError,
  AddFormTagResponse,
  AddOfferingSeatTypesData,
  AddOfferingSeatTypesError,
  AddOfferingSeatTypesResponse,
  AddSchoolToFormData,
  AddSchoolToFormError,
  AddSchoolToFormResponse2,
  ArchiveTeamMembersData,
  ArchiveTeamMembersError,
  ArchiveTeamMembersResponse,
  BulkAcceptOfferData,
  BulkAcceptOfferError,
  BulkAcceptOfferResponse,
  BulkDeclineOfferData,
  BulkDeclineOfferError,
  BulkDeclineOfferResponse,
  BulkGetOfferExpirationInfoData,
  BulkGetOfferExpirationInfoError,
  BulkGetOfferExpirationInfoResponse,
  BulkMakeOffersData,
  BulkMakeOffersError,
  BulkMakeOffersResponse,
  BulkRevokeOfferData,
  BulkRevokeOfferError,
  BulkRevokeOfferResponse,
  BulkSetOfferExpirationData,
  BulkSetOfferExpirationError,
  BulkSetOfferExpirationResponse,
  CancelPaymentData,
  CancelPaymentError,
  CancelPaymentResponse2,
  CheckEligibilityData,
  CheckEligibilityError,
  CheckEligibilityResponse2,
  CheckoutData,
  CheckoutError,
  CheckoutResponse,
  ClearAnswerData,
  ClearAnswerError,
  ClearAnswerForMeData,
  ClearAnswerForMeError,
  ClearAnswerForMeResponse,
  ClearAnswerResponse,
  ClearSubStatusData,
  ClearSubStatusError,
  ClearSubStatusResponse,
  ConnectStripeAccountData,
  ConnectStripeAccountError,
  ConnectStripeAccountResponse,
  CreateApiCredentialData,
  CreateApiCredentialError,
  CreateApiCredentialResponse,
  CreateBoundaryConnectionsData,
  CreateBoundaryConnectionsError,
  CreateBoundaryConnectionsResponse,
  CreateBulkFormActionData,
  CreateBulkFormActionError,
  CreateBulkFormActionResponse,
  CreateBulkFormTagActionData,
  CreateBulkFormTagActionError,
  CreateBulkFormTagActionResponse,
  CreateBulkOfferActionData,
  CreateBulkOfferActionError,
  CreateBulkOfferActionResponse,
  CreateBulkSubstatusActionData,
  CreateBulkSubstatusActionError,
  CreateBulkSubstatusActionResponse,
  CreateBulkWaitlistActionData,
  CreateBulkWaitlistActionError,
  CreateBulkWaitlistActionResponse,
  CreateFamilyData,
  CreateFamilyError,
  CreateFamilyResponse2,
  CreateFormForAdminData,
  CreateFormForAdminError,
  CreateFormForAdminResponse,
  CreateFormRuleData,
  CreateFormRuleError,
  CreateFormRuleResponse,
  CreateFormTemplateData,
  CreateFormTemplateError,
  CreateFormTemplateResponse,
  CreateLoginPrefillTokenData,
  CreateLoginPrefillTokenError,
  CreateLoginPrefillTokenResponse,
  CreateMatchRunData,
  CreateMatchRunError,
  CreateMatchRunResponse2,
  CreateOfferConfigurationData,
  CreateOfferConfigurationError,
  CreateOfferConfigurationResponse,
  CreateOfferingCategoriesData,
  CreateOfferingCategoriesError,
  CreateOfferingCategoriesResponse,
  CreateOfferingsData,
  CreateOfferingsError,
  CreateOfferingsResponse,
  CreateOrganizationData,
  CreateOrganizationError,
  CreateOrganizationResponse,
  CreatePaymentsData,
  CreatePaymentsError,
  CreatePaymentsResponse2,
  CreatePaymentTemplateData,
  CreatePaymentTemplateError,
  CreatePaymentTemplateResponse,
  CreateRuleExecutionsData,
  CreateRuleExecutionsError,
  CreateRuleExecutionsForMeData,
  CreateRuleExecutionsForMeError,
  CreateRuleExecutionsForMeResponse,
  CreateRuleExecutionsResponse,
  CreateTagData,
  CreateTagError,
  CreateTagGroupData,
  CreateTagGroupError,
  CreateTagGroupResponse,
  CreateTagResponse,
  CreateTeamMemberData,
  CreateTeamMemberError,
  CreateTeamMemberResponse,
  DeclineOfferData,
  DeclineOfferError,
  DeclineOfferResponse,
  DeleteApiCredentialData,
  DeleteApiCredentialError,
  DeleteApiCredentialResponse,
  DeleteBoundariesData,
  DeleteBoundariesError,
  DeleteBoundariesResponse,
  DeleteBoundaryConnectionsData,
  DeleteBoundaryConnectionsError,
  DeleteBoundaryConnectionsResponse,
  DeleteFormForMeData,
  DeleteFormForMeError,
  DeleteFormForMeResponse,
  DeleteFormRuleData,
  DeleteFormRuleError,
  DeleteFormRuleResponse,
  DeleteOfferConfigurationData,
  DeleteOfferConfigurationError,
  DeleteOfferConfigurationResponse,
  DeleteOfferingCategoryData,
  DeleteOfferingCategoryError,
  DeleteOfferingCategoryResponse,
  DeleteOfferingData,
  DeleteOfferingError,
  DeleteOfferingResponse,
  DeleteOfferingSeatTypeData,
  DeleteOfferingSeatTypeError,
  DeleteOfferingSeatTypeResponse,
  DeletePaymentTemplateData,
  DeletePaymentTemplateError,
  DeletePaymentTemplateResponse2,
  DeleteTagData,
  DeleteTagError,
  DeleteTagGroupData,
  DeleteTagGroupError,
  DeleteTagGroupResponse,
  DeleteTagResponse,
  DeleteUnpublishedFormSchemaData,
  DeleteUnpublishedFormSchemaError,
  DeleteUnpublishedFormSchemaResponse,
  DeleteWaitlistsData,
  DeleteWaitlistsError,
  DeleteWaitlistsResponse,
  DiffFormSchemaData,
  DiffFormSchemaError,
  DiffFormSchemaResponse,
  DisconnectStripeAccountData,
  DisconnectStripeAccountError,
  DisconnectStripeAccountResponse,
  EditTeamMemberData,
  EditTeamMemberError,
  EditTeamMemberResponse,
  ExcludeData,
  ExcludeError,
  ExcludeResponse,
  ExportBoundariesByOrgGeoJsonData,
  ExportBoundariesByOrgGeoJsonError,
  ExportBoundariesByOrgGeoJsonResponse,
  ExportBoundaryGeoJsonData,
  ExportBoundaryGeoJsonError,
  ExportBoundaryGeoJsonResponse,
  ExportBulkActionItemsData,
  ExportBulkActionItemsError,
  ExportBulkActionItemsResponse2,
  ExportCapacitiesByEnrollmentPeriodData,
  ExportCapacitiesByEnrollmentPeriodError,
  ExportCapacitiesByEnrollmentPeriodResponse,
  ExportCapacitiesBySchoolAndEnrollmentPeriodData,
  ExportCapacitiesBySchoolAndEnrollmentPeriodError,
  ExportCapacitiesBySchoolAndEnrollmentPeriodResponse,
  ExportFormTemplateData,
  ExportFormTemplateError,
  ExportFormTemplateResponse,
  ExportMessageTemplatesData,
  ExportMessageTemplatesError,
  ExportMessageTemplatesResponse,
  ExportRuleConfigurationData,
  ExportRuleConfigurationError,
  ExportRuleConfigurationResponse,
  ExportSchoolBoundaryConnectionsData,
  ExportSchoolBoundaryConnectionsError,
  ExportSchoolBoundaryConnectionsResponse,
  ExportSchoolsAndGradesForEnrollmentPeriodData,
  ExportSchoolsAndGradesForEnrollmentPeriodError,
  ExportSchoolsAndGradesForEnrollmentPeriodResponse,
  FetchFormSchoolTagsData,
  FetchFormSchoolTagsError,
  FetchFormSchoolTagsResponse,
  FetchFormTagsData,
  FetchFormTagsError,
  FetchFormTagsResponse,
  FetchTagGroupsData,
  FetchTagGroupsError,
  FetchTagGroupsResponse,
  FetchTagsData,
  FetchTagsError,
  FetchTagsResponse,
  GenerateBannerImageUploadUrlData,
  GenerateBannerImageUploadUrlError,
  GenerateBannerImageUploadUrlResponse,
  GenerateUploadUrlData,
  GenerateUploadUrlError,
  GenerateUploadUrlResponse,
  GeocodeAnswerData,
  GeocodeAnswerError,
  GeocodeAnswerResponse,
  GeocodeFormsData,
  GeocodeFormsError,
  GeocodeFormsResponse,
  GetActiveFormsForApplicantData,
  GetActiveFormsForApplicantError,
  GetActiveFormsForApplicantResponse,
  GetAdminGreetingData,
  GetAdminGreetingError,
  GetAdminGreetingResponse,
  GetAdminPaymentReceiptData,
  GetAdminPaymentReceiptError,
  GetAdminPaymentReceiptResponse,
  GetAdmissionsForMeData,
  GetAdmissionsForMeError,
  GetAdmissionsForMeResponse2,
  GetAnswersData,
  GetAnswersError,
  GetAnswersForMeData,
  GetAnswersForMeError,
  GetAnswersForMeResponse,
  GetAnswersResponse,
  GetApiCredentialData,
  GetApiCredentialError,
  GetApiCredentialResponse,
  GetBoundariesByOrgIdData,
  GetBoundariesByOrgIdError,
  GetBoundariesByOrgIdResponse,
  GetBoundariesData,
  GetBoundariesError,
  GetBoundariesMetadataData,
  GetBoundariesMetadataError,
  GetBoundariesMetadataResponse,
  GetBoundariesResponse,
  GetBoundaryConnectionsBySchoolIdData,
  GetBoundaryConnectionsBySchoolIdError,
  GetBoundaryConnectionsBySchoolIdResponse,
  GetBoundaryMapByEnrollmentPeriodIdData,
  GetBoundaryMapByEnrollmentPeriodIdError,
  GetBoundaryMapByEnrollmentPeriodIdOptimizedData,
  GetBoundaryMapByEnrollmentPeriodIdOptimizedError,
  GetBoundaryMapByEnrollmentPeriodIdOptimizedResponse,
  GetBoundaryMapByEnrollmentPeriodIdResponse,
  GetBoundaryMapByFormIdData,
  GetBoundaryMapByFormIdError,
  GetBoundaryMapByFormIdOptimizedData,
  GetBoundaryMapByFormIdOptimizedError,
  GetBoundaryMapByFormIdOptimizedResponse,
  GetBoundaryMapByFormIdResponse,
  GetBulkActionData,
  GetBulkActionError,
  GetBulkActionProgressData,
  GetBulkActionProgressError,
  GetBulkActionProgressResponse,
  GetBulkActionResponse2,
  GetCapacitiesBySchoolAndEnrollmentPeriodData,
  GetCapacitiesBySchoolAndEnrollmentPeriodError,
  GetCapacitiesBySchoolAndEnrollmentPeriodResponse,
  GetCapacitiesConfigByEnrollmentPeriodData,
  GetCapacitiesConfigByEnrollmentPeriodError,
  GetCapacitiesConfigByEnrollmentPeriodResponse,
  GetCapacitiesHistoryData,
  GetCapacitiesHistoryDetailData,
  GetCapacitiesHistoryDetailError,
  GetCapacitiesHistoryDetailResponse,
  GetCapacitiesHistoryError,
  GetCapacitiesHistoryResponse,
  GetCapacitySummaryByEnrollmentPeriodData,
  GetCapacitySummaryByEnrollmentPeriodError,
  GetCapacitySummaryByEnrollmentPeriodResponse,
  GetDashboardFormResponsesOverTimeData,
  GetDashboardFormResponsesOverTimeError,
  GetDashboardFormResponsesOverTimeResponse,
  GetDashboardFormSchoolGradeRankData,
  GetDashboardFormSchoolGradeRankError,
  GetDashboardFormSchoolGradeRankResponse,
  GetDashboardFormStatusData,
  GetDashboardFormStatusError,
  GetDashboardFormStatusResponse,
  GetDashboardFormSubstatusData,
  GetDashboardFormSubstatusError,
  GetDashboardFormSubstatusResponse,
  GetEligibleFormTemplatesForApplicantData,
  GetEligibleFormTemplatesForApplicantError,
  GetEligibleFormTemplatesForApplicantResponse,
  GetEligibleFormTemplatesForMeData,
  GetEligibleFormTemplatesForMeError,
  GetEligibleFormTemplatesForMeResponse,
  GetFormAlertsByFormIdData,
  GetFormAlertsByFormIdError,
  GetFormAlertsByFormIdResponse,
  GetFormData,
  GetFormError,
  GetFormResponse,
  GetFormRuleData,
  GetFormRuleError,
  GetFormRuleResponse,
  GetFormsData,
  GetFormsError,
  GetFormsResponse,
  GetFormTemplateData,
  GetFormTemplateError,
  GetFormTemplateResponse,
  GetFormTemplateSettingsData,
  GetFormTemplateSettingsError,
  GetFormTemplateSettingsForMeData,
  GetFormTemplateSettingsForMeError,
  GetFormTemplateSettingsForMeResponse,
  GetFormTemplateSettingsResponse,
  GetGradeConfigByEnrollmentPeriodData,
  GetGradeConfigByEnrollmentPeriodError,
  GetGradeConfigByEnrollmentPeriodResponse,
  GetMatchRunData,
  GetMatchRunDetailsData,
  GetMatchRunDetailsError,
  GetMatchRunDetailsResponse2,
  GetMatchRunError,
  GetMatchRunResponse2,
  GetOfferConfigurationByIdData,
  GetOfferConfigurationByIdError,
  GetOfferConfigurationByIdResponse,
  GetOfferConfigurationsByEnrollmentPeriodIdData,
  GetOfferConfigurationsByEnrollmentPeriodIdError,
  GetOfferConfigurationsByEnrollmentPeriodIdResponse,
  GetOfferConfigurationsByFormTemplateIdData,
  GetOfferConfigurationsByFormTemplateIdError,
  GetOfferConfigurationsByFormTemplateIdResponse,
  GetOfferingCategoriesData,
  GetOfferingCategoriesError,
  GetOfferingCategoriesResponse,
  GetOfferingsData,
  GetOfferingsError,
  GetOfferingsResponse,
  GetOffersForMeData,
  GetOffersForMeError,
  GetOffersForMeResponse,
  GetOrganizationConfigData,
  GetOrganizationConfigError,
  GetOrganizationConfigResponse,
  GetPaymentReceiptData,
  GetPaymentReceiptError,
  GetPaymentReceiptResponse,
  GetPaymentsForMeData,
  GetPaymentsForMeError,
  GetPaymentsForMeResponse,
  GetPaymentTemplateData,
  GetPaymentTemplateError,
  GetPaymentTemplateResponse,
  GetSchoolsByEnrollmentPeriodData,
  GetSchoolsByEnrollmentPeriodError,
  GetSchoolsByEnrollmentPeriodResponse,
  GetSchoolsData,
  GetSchoolsError,
  GetSchoolsResponse,
  GetStaffCreatePrecheckData,
  GetStaffCreatePrecheckError,
  GetStaffCreatePrecheckResponse,
  GetTagUsageCountData,
  GetTagUsageCountError,
  GetTagUsageCountResponse,
  ImportBoundaryConnectionsFromEnrollmentPeriodData,
  ImportBoundaryConnectionsFromEnrollmentPeriodError,
  ImportBoundaryConnectionsFromEnrollmentPeriodResponse,
  ImportCapacitiesByEnrollmentPeriodData,
  ImportCapacitiesByEnrollmentPeriodError,
  ImportCapacitiesByEnrollmentPeriodResponse,
  ImportFormTemplateFromJsonData,
  ImportFormTemplateFromJsonError,
  ImportFormTemplateFromJsonResponse,
  ImportFormTemplateFromOtherData,
  ImportFormTemplateFromOtherError,
  ImportFormTemplateFromOtherResponse,
  ImportMessageTemplatesData,
  ImportMessageTemplatesError,
  ImportMessageTemplatesFromOtherData,
  ImportMessageTemplatesFromOtherError,
  ImportMessageTemplatesFromOtherResponse,
  ImportMessageTemplatesResponse,
  ImportRuleConfigurationData,
  ImportRuleConfigurationError,
  ImportRuleConfigurationResponse,
  ImportSchoolBoundaryConnectionsData,
  ImportSchoolBoundaryConnectionsError,
  ImportSchoolBoundaryConnectionsResponse,
  ImportSchoolsAndGradesForEnrollmentPeriodData,
  ImportSchoolsAndGradesForEnrollmentPeriodError,
  ImportSchoolsAndGradesForEnrollmentPeriodResponse,
  ImportSchoolsAndGradesFromOthersForEnrollmentPeriodData,
  ImportSchoolsAndGradesFromOthersForEnrollmentPeriodError,
  ImportSchoolsAndGradesFromOthersForEnrollmentPeriodResponse,
  ListAllowedSubStatusTransitionsData,
  ListAllowedSubStatusTransitionsError,
  ListAllowedSubStatusTransitionsResponse,
  ListApiCredentialsData,
  ListApiCredentialsError,
  ListApiCredentialsResponse,
  ListBulkActionItemsData,
  ListBulkActionItemsError,
  ListBulkActionItemsResponse2,
  ListBulkActionsData,
  ListBulkActionsError,
  ListBulkActionsResponse2,
  ListCapacitiesByEnrollmentPeriodData,
  ListCapacitiesByEnrollmentPeriodError,
  ListCapacitiesByEnrollmentPeriodResponse,
  ListCapacitiesBySchoolAndEnrollmentPeriodData,
  ListCapacitiesBySchoolAndEnrollmentPeriodError,
  ListCapacitiesBySchoolAndEnrollmentPeriodResponse,
  ListFormIdsAdvancedData,
  ListFormIdsAdvancedError,
  ListFormIdsAdvancedResponse,
  ListFormIdsAdvancedV2Data,
  ListFormIdsAdvancedV2Error,
  ListFormIdsAdvancedV2Response,
  ListFormIdsData,
  ListFormIdsError,
  ListFormIdsResponse,
  ListFormIdsV2Data,
  ListFormIdsV2Error,
  ListFormIdsV2Response,
  ListFormsAdvancedData,
  ListFormsAdvancedError,
  ListFormsAdvancedResponse,
  ListFormsData,
  ListFormsError,
  ListFormsFromSelectionData,
  ListFormsFromSelectionError,
  ListFormsFromSelectionResponse,
  ListFormsResponse,
  ListFormTemplatesSettingsData,
  ListFormTemplatesSettingsError,
  ListFormTemplatesSettingsResponse,
  ListMatchRunsData,
  ListMatchRunsError,
  ListMatchRunsResponse2,
  ListPaymentsData,
  ListPaymentsError,
  ListPaymentsResponse2,
  ListPaymentTemplatesData,
  ListPaymentTemplatesError,
  ListPaymentTemplatesResponse2,
  ListTeamsData,
  ListTeamsError,
  ListTeamsResponse,
  ListUserGroupsError,
  ListUserGroupsResponse,
  ParentGetBoundaryMapByEnrollmentPeriodIdData,
  ParentGetBoundaryMapByEnrollmentPeriodIdError,
  ParentGetBoundaryMapByEnrollmentPeriodIdOptimizedData,
  ParentGetBoundaryMapByEnrollmentPeriodIdOptimizedError,
  ParentGetBoundaryMapByEnrollmentPeriodIdOptimizedResponse,
  ParentGetBoundaryMapByEnrollmentPeriodIdResponse,
  ParentGetBoundaryMapByFormIdData,
  ParentGetBoundaryMapByFormIdError,
  ParentGetBoundaryMapByFormIdOptimizedData,
  ParentGetBoundaryMapByFormIdOptimizedError,
  ParentGetBoundaryMapByFormIdOptimizedResponse,
  ParentGetBoundaryMapByFormIdResponse,
  PostBoundariesData,
  PostBoundariesError,
  PostBoundariesResponse,
  PostWaitlistsData,
  PostWaitlistsError,
  PostWaitlistsResponse,
  PublishFormSchemaData,
  PublishFormSchemaError,
  PublishFormSchemaResponse,
  PublishMatchRunData,
  PublishMatchRunError,
  PublishMatchRunResponse,
  PutAnswerData,
  PutAnswerError,
  PutAnswerForMeData,
  PutAnswerForMeError,
  PutAnswerForMeResponse,
  PutAnswerResponse,
  PutAnswersData,
  PutAnswersError,
  PutAnswersForMeData,
  PutAnswersForMeError,
  PutAnswersForMeResponse,
  PutAnswersResponse,
  RemoveFormSchoolTagData,
  RemoveFormSchoolTagError,
  RemoveFormSchoolTagResponse,
  RemoveFormTagData,
  RemoveFormTagError,
  RemoveFormTagResponse,
  ResendVerificationEmailData,
  ResendVerificationEmailError,
  ResendVerificationEmailResponse,
  ResetFormForMeData,
  ResetFormForMeError,
  ResetFormForMeResponse,
  ResetTeamMemberMfaData,
  ResetTeamMemberMfaError,
  ResetTeamMemberMfaResponse,
  RotateApiCredentialSecretData,
  RotateApiCredentialSecretError,
  RotateApiCredentialSecretResponse,
  SearchApplicantDuplicatesData,
  SearchApplicantDuplicatesError,
  SearchApplicantDuplicatesResponse2,
  SearchApplicantsData,
  SearchApplicantsError,
  SearchApplicantsResponse2,
  SearchParentsData,
  SearchParentsError,
  SearchParentsResponse2,
  SendPasswordResetData,
  SendPasswordResetError,
  SendPasswordResetResponse,
  SubmitFormForMeData,
  SubmitFormForMeError,
  SubmitFormForMeResponse,
  UpdateApiCredentialData,
  UpdateApiCredentialError,
  UpdateApiCredentialResponse,
  UpdateBoundaryByIdData,
  UpdateBoundaryByIdError,
  UpdateBoundaryByIdResponse,
  UpdateBoundaryConnectionsData,
  UpdateBoundaryConnectionsError,
  UpdateBoundaryConnectionsResponse,
  UpdateCapacitiesByEnrollmentPeriodData,
  UpdateCapacitiesByEnrollmentPeriodError,
  UpdateCapacitiesByEnrollmentPeriodResponse,
  UpdateCapacitiesConfigByEnrollmentPeriodData,
  UpdateCapacitiesConfigByEnrollmentPeriodError,
  UpdateCapacitiesConfigByEnrollmentPeriodResponse,
  UpdateFormRuleActiveStatusData,
  UpdateFormRuleActiveStatusError,
  UpdateFormRuleActiveStatusResponse,
  UpdateFormRuleData,
  UpdateFormRuleError,
  UpdateFormRuleResponse,
  UpdateFormSchemaData,
  UpdateFormSchemaError,
  UpdateFormSchemaResponse,
  UpdateFormsStatusForAdminData,
  UpdateFormsStatusForAdminError,
  UpdateFormsStatusForAdminResponse,
  UpdateFormTemplateData,
  UpdateFormTemplateError,
  UpdateFormTemplateResponse,
  UpdateFormTemplateSettingsData,
  UpdateFormTemplateSettingsError,
  UpdateFormTemplateSettingsResponse,
  UpdateOfferConfigurationData,
  UpdateOfferConfigurationError,
  UpdateOfferConfigurationResponse,
  UpdateOfferingCategoryData,
  UpdateOfferingCategoryError,
  UpdateOfferingCategoryResponse,
  UpdateOrganizationConfigData,
  UpdateOrganizationConfigError,
  UpdateOrganizationConfigResponse,
  UpdatePaymentTemplateData,
  UpdatePaymentTemplateError,
  UpdatePaymentTemplateResponse,
  UpdateTagData,
  UpdateTagError,
  UpdateTagGroupData,
  UpdateTagGroupError,
  UpdateTagGroupResponse,
  UpdateTagResponse,
  ValidateFormSchemaData,
  ValidateFormSchemaError,
  ValidateFormSchemaResponse,
  WithdrawFromWaitlistData,
  WithdrawFromWaitlistError,
  WithdrawFromWaitlistResponse,
} from "./types.gen";

export const client = createClient(createConfig());

export const createFormForAdmin = <ThrowOnError extends boolean = false>(
  options: Options<CreateFormForAdminData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    CreateFormForAdminResponse,
    CreateFormForAdminError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/forms/",
  });
};

export const checkEligibility = <ThrowOnError extends boolean = false>(
  options: Options<CheckEligibilityData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    CheckEligibilityResponse2,
    CheckEligibilityError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/forms/eligibility",
  });
};

export const getStaffCreatePrecheck = <ThrowOnError extends boolean = false>(
  options: Options<GetStaffCreatePrecheckData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetStaffCreatePrecheckResponse,
    GetStaffCreatePrecheckError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/forms/staff-create-precheck",
  });
};

export const addSchoolToForm = <ThrowOnError extends boolean = false>(
  options: Options<AddSchoolToFormData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    AddSchoolToFormResponse2,
    AddSchoolToFormError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/forms/add-school",
  });
};

export const getActiveFormsForApplicant = <
  ThrowOnError extends boolean = false
>(
  options: Options<GetActiveFormsForApplicantData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetActiveFormsForApplicantResponse,
    GetActiveFormsForApplicantError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/forms/active",
  });
};

export const getForm = <ThrowOnError extends boolean = false>(
  options: Options<GetFormData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetFormResponse,
    GetFormError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/forms/{formId}",
  });
};

export const getForms = <ThrowOnError extends boolean = false>(
  options: Options<GetFormsData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    GetFormsResponse,
    GetFormsError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/forms/list",
  });
};

export const updateFormsStatusForAdmin = <ThrowOnError extends boolean = false>(
  options: Options<UpdateFormsStatusForAdminData, ThrowOnError>
) => {
  return (options?.client ?? client).put<
    UpdateFormsStatusForAdminResponse,
    UpdateFormsStatusForAdminError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/forms/status",
  });
};

export const createBulkFormAction = <ThrowOnError extends boolean = false>(
  options: Options<CreateBulkFormActionData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    CreateBulkFormActionResponse,
    CreateBulkFormActionError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/forms/bulk-actions",
  });
};

export const getAnswers = <ThrowOnError extends boolean = false>(
  options: Options<GetAnswersData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetAnswersResponse,
    GetAnswersError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/forms/{formId}/answers/",
  });
};

export const putAnswers = <ThrowOnError extends boolean = false>(
  options: Options<PutAnswersData, ThrowOnError>
) => {
  return (options?.client ?? client).put<
    PutAnswersResponse,
    PutAnswersError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/forms/{formId}/answers/",
  });
};

export const putAnswer = <ThrowOnError extends boolean = false>(
  options: Options<PutAnswerData, ThrowOnError>
) => {
  return (options?.client ?? client).put<
    PutAnswerResponse,
    PutAnswerError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/forms/{formId}/answers/{questionId}",
  });
};

export const clearAnswer = <ThrowOnError extends boolean = false>(
  options: Options<ClearAnswerData, ThrowOnError>
) => {
  return (options?.client ?? client).delete<
    ClearAnswerResponse,
    ClearAnswerError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/forms/{formId}/answers/{questionId}",
  });
};

export const geocodeAnswer = <ThrowOnError extends boolean = false>(
  options: Options<GeocodeAnswerData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    GeocodeAnswerResponse,
    GeocodeAnswerError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/forms/{formId}/answers/{questionId}/geocode",
  });
};

export const bulkMakeOffers = <ThrowOnError extends boolean = false>(
  options: Options<BulkMakeOffersData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    BulkMakeOffersResponse,
    BulkMakeOffersError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/forms/offers/make",
  });
};

export const bulkAcceptOffer = <ThrowOnError extends boolean = false>(
  options: Options<BulkAcceptOfferData, ThrowOnError>
) => {
  return (options?.client ?? client).put<
    BulkAcceptOfferResponse,
    BulkAcceptOfferError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/forms/offers/accept",
  });
};

export const bulkDeclineOffer = <ThrowOnError extends boolean = false>(
  options: Options<BulkDeclineOfferData, ThrowOnError>
) => {
  return (options?.client ?? client).put<
    BulkDeclineOfferResponse,
    BulkDeclineOfferError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/forms/offers/decline",
  });
};

export const bulkRevokeOffer = <ThrowOnError extends boolean = false>(
  options: Options<BulkRevokeOfferData, ThrowOnError>
) => {
  return (options?.client ?? client).put<
    BulkRevokeOfferResponse,
    BulkRevokeOfferError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/forms/offers/revoke",
  });
};

export const bulkGetOfferExpirationInfo = <
  ThrowOnError extends boolean = false
>(
  options: Options<BulkGetOfferExpirationInfoData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    BulkGetOfferExpirationInfoResponse,
    BulkGetOfferExpirationInfoError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/forms/offers/getExpirationInfo",
  });
};

export const bulkSetOfferExpiration = <ThrowOnError extends boolean = false>(
  options: Options<BulkSetOfferExpirationData, ThrowOnError>
) => {
  return (options?.client ?? client).patch<
    BulkSetOfferExpirationResponse,
    BulkSetOfferExpirationError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/forms/offers/bulkSetOfferExpiration",
  });
};

export const createBulkOfferAction = <ThrowOnError extends boolean = false>(
  options: Options<CreateBulkOfferActionData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    CreateBulkOfferActionResponse,
    CreateBulkOfferActionError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/forms/offers/bulk-actions",
  });
};

export const getOfferConfigurationById = <ThrowOnError extends boolean = false>(
  options: Options<GetOfferConfigurationByIdData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetOfferConfigurationByIdResponse,
    GetOfferConfigurationByIdError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/forms/offers/configuration/{id}",
  });
};

export const updateOfferConfiguration = <ThrowOnError extends boolean = false>(
  options: Options<UpdateOfferConfigurationData, ThrowOnError>
) => {
  return (options?.client ?? client).put<
    UpdateOfferConfigurationResponse,
    UpdateOfferConfigurationError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/forms/offers/configuration/{id}",
  });
};

export const deleteOfferConfiguration = <ThrowOnError extends boolean = false>(
  options: Options<DeleteOfferConfigurationData, ThrowOnError>
) => {
  return (options?.client ?? client).delete<
    DeleteOfferConfigurationResponse,
    DeleteOfferConfigurationError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/forms/offers/configuration/{id}",
  });
};

export const getOfferConfigurationsByEnrollmentPeriodId = <
  ThrowOnError extends boolean = false
>(
  options: Options<GetOfferConfigurationsByEnrollmentPeriodIdData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetOfferConfigurationsByEnrollmentPeriodIdResponse,
    GetOfferConfigurationsByEnrollmentPeriodIdError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/forms/offers/configuration/",
  });
};

export const createOfferConfiguration = <ThrowOnError extends boolean = false>(
  options: Options<CreateOfferConfigurationData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    CreateOfferConfigurationResponse,
    CreateOfferConfigurationError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/forms/offers/configuration/",
  });
};

export const getOfferConfigurationsByFormTemplateId = <
  ThrowOnError extends boolean = false
>(
  options: Options<GetOfferConfigurationsByFormTemplateIdData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetOfferConfigurationsByFormTemplateIdResponse,
    GetOfferConfigurationsByFormTemplateIdError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/forms/offers/configuration/form-template/{formTemplateId}",
  });
};

export const deleteWaitlists = <ThrowOnError extends boolean = false>(
  options: Options<DeleteWaitlistsData, ThrowOnError>
) => {
  return (options?.client ?? client).delete<
    DeleteWaitlistsResponse,
    DeleteWaitlistsError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/forms/waitlists/",
  });
};

export const postWaitlists = <ThrowOnError extends boolean = false>(
  options: Options<PostWaitlistsData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    PostWaitlistsResponse,
    PostWaitlistsError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/forms/waitlists/",
  });
};

export const createBulkWaitlistAction = <ThrowOnError extends boolean = false>(
  options: Options<CreateBulkWaitlistActionData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    CreateBulkWaitlistActionResponse,
    CreateBulkWaitlistActionError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/forms/waitlists/bulk-actions",
  });
};

export const clearSubStatus = <ThrowOnError extends boolean = false>(
  options: Options<ClearSubStatusData, ThrowOnError>
) => {
  return (options?.client ?? client).delete<
    ClearSubStatusResponse,
    ClearSubStatusError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/forms/sub-status/clear-sub-status",
  });
};

export const exclude = <ThrowOnError extends boolean = false>(
  options: Options<ExcludeData, ThrowOnError>
) => {
  return (options?.client ?? client).put<
    ExcludeResponse,
    ExcludeError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/forms/sub-status/exclude",
  });
};

export const createBulkSubstatusAction = <ThrowOnError extends boolean = false>(
  options: Options<CreateBulkSubstatusActionData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    CreateBulkSubstatusActionResponse,
    CreateBulkSubstatusActionError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/forms/sub-status/bulk-actions",
  });
};

export const listAllowedSubStatusTransitions = <
  ThrowOnError extends boolean = false
>(
  options: Options<ListAllowedSubStatusTransitionsData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    ListAllowedSubStatusTransitionsResponse,
    ListAllowedSubStatusTransitionsError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/forms/sub-status/list-allowed-sub-status-transitions",
  });
};

export const geocodeForms = <ThrowOnError extends boolean = false>(
  options: Options<GeocodeFormsData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    GeocodeFormsResponse,
    GeocodeFormsError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/forms/geocodeForms",
  });
};

export const listForms = <ThrowOnError extends boolean = false>(
  options: Options<ListFormsData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    ListFormsResponse,
    ListFormsError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/form-list/",
  });
};

export const listFormsAdvanced = <ThrowOnError extends boolean = false>(
  options: Options<ListFormsAdvancedData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    ListFormsAdvancedResponse,
    ListFormsAdvancedError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/form-list/",
  });
};

export const listFormsFromSelection = <ThrowOnError extends boolean = false>(
  options: Options<ListFormsFromSelectionData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    ListFormsFromSelectionResponse,
    ListFormsFromSelectionError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/form-list/selection",
  });
};

export const listFormIds = <ThrowOnError extends boolean = false>(
  options: Options<ListFormIdsData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    ListFormIdsResponse,
    ListFormIdsError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/form-list/id",
  });
};

export const listFormIdsAdvanced = <ThrowOnError extends boolean = false>(
  options: Options<ListFormIdsAdvancedData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    ListFormIdsAdvancedResponse,
    ListFormIdsAdvancedError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/form-list/id",
  });
};

export const listFormIdsV2 = <ThrowOnError extends boolean = false>(
  options: Options<ListFormIdsV2Data, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    ListFormIdsV2Response,
    ListFormIdsV2Error,
    ThrowOnError
  >({
    ...options,
    url: "/admin/form-list/id/v2",
  });
};

export const listFormIdsAdvancedV2 = <ThrowOnError extends boolean = false>(
  options: Options<ListFormIdsAdvancedV2Data, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    ListFormIdsAdvancedV2Response,
    ListFormIdsAdvancedV2Error,
    ThrowOnError
  >({
    ...options,
    url: "/admin/form-list/id/v2",
  });
};

export const listBulkActions = <ThrowOnError extends boolean = false>(
  options: Options<ListBulkActionsData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    ListBulkActionsResponse2,
    ListBulkActionsError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/bulk-actions/",
  });
};

export const getBulkActionProgress = <ThrowOnError extends boolean = false>(
  options: Options<GetBulkActionProgressData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetBulkActionProgressResponse,
    GetBulkActionProgressError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/bulk-actions/{bulkActionId}/progress",
  });
};

export const getBulkAction = <ThrowOnError extends boolean = false>(
  options: Options<GetBulkActionData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetBulkActionResponse2,
    GetBulkActionError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/bulk-actions/{bulkActionId}",
  });
};

export const exportBulkActionItems = <ThrowOnError extends boolean = false>(
  options: Options<ExportBulkActionItemsData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    ExportBulkActionItemsResponse2,
    ExportBulkActionItemsError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/bulk-actions/{bulkActionId}/items/export",
  });
};

export const listBulkActionItems = <ThrowOnError extends boolean = false>(
  options: Options<ListBulkActionItemsData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    ListBulkActionItemsResponse2,
    ListBulkActionItemsError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/bulk-actions/{bulkActionId}/items",
  });
};

export const fetchFormTags = <ThrowOnError extends boolean = false>(
  options: Options<FetchFormTagsData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    FetchFormTagsResponse,
    FetchFormTagsError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/tags/forms",
  });
};

export const removeFormTag = <ThrowOnError extends boolean = false>(
  options: Options<RemoveFormTagData, ThrowOnError>
) => {
  return (options?.client ?? client).delete<
    RemoveFormTagResponse,
    RemoveFormTagError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/tags/forms",
  });
};

export const addFormTag = <ThrowOnError extends boolean = false>(
  options: Options<AddFormTagData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    AddFormTagResponse,
    AddFormTagError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/tags/forms",
  });
};

export const createBulkFormTagAction = <ThrowOnError extends boolean = false>(
  options: Options<CreateBulkFormTagActionData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    CreateBulkFormTagActionResponse,
    CreateBulkFormTagActionError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/tags/forms/bulk-actions",
  });
};

export const fetchFormSchoolTags = <ThrowOnError extends boolean = false>(
  options: Options<FetchFormSchoolTagsData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    FetchFormSchoolTagsResponse,
    FetchFormSchoolTagsError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/tags/schools",
  });
};

export const addFormSchoolTag = <ThrowOnError extends boolean = false>(
  options: Options<AddFormSchoolTagData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    AddFormSchoolTagResponse,
    AddFormSchoolTagError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/tags/schools",
  });
};

export const removeFormSchoolTag = <ThrowOnError extends boolean = false>(
  options: Options<RemoveFormSchoolTagData, ThrowOnError>
) => {
  return (options?.client ?? client).delete<
    RemoveFormSchoolTagResponse,
    RemoveFormSchoolTagError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/tags/schools",
  });
};

export const fetchTagGroups = <ThrowOnError extends boolean = false>(
  options?: Options<FetchTagGroupsData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    FetchTagGroupsResponse,
    FetchTagGroupsError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/tags/tag-groups",
  });
};

export const createTagGroup = <ThrowOnError extends boolean = false>(
  options: Options<CreateTagGroupData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    CreateTagGroupResponse,
    CreateTagGroupError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/tags/tag-groups",
  });
};

export const updateTagGroup = <ThrowOnError extends boolean = false>(
  options: Options<UpdateTagGroupData, ThrowOnError>
) => {
  return (options?.client ?? client).put<
    UpdateTagGroupResponse,
    UpdateTagGroupError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/tags/tag-groups/{id}",
  });
};

export const deleteTagGroup = <ThrowOnError extends boolean = false>(
  options: Options<DeleteTagGroupData, ThrowOnError>
) => {
  return (options?.client ?? client).delete<
    DeleteTagGroupResponse,
    DeleteTagGroupError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/tags/tag-groups/{id}",
  });
};

export const fetchTags = <ThrowOnError extends boolean = false>(
  options?: Options<FetchTagsData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    FetchTagsResponse,
    FetchTagsError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/tags",
  });
};

export const createTag = <ThrowOnError extends boolean = false>(
  options: Options<CreateTagData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    CreateTagResponse,
    CreateTagError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/tags",
  });
};

export const updateTag = <ThrowOnError extends boolean = false>(
  options: Options<UpdateTagData, ThrowOnError>
) => {
  return (options?.client ?? client).put<
    UpdateTagResponse,
    UpdateTagError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/tags/{id}",
  });
};

export const deleteTag = <ThrowOnError extends boolean = false>(
  options: Options<DeleteTagData, ThrowOnError>
) => {
  return (options?.client ?? client).delete<
    DeleteTagResponse,
    DeleteTagError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/tags/{id}",
  });
};

export const getTagUsageCount = <ThrowOnError extends boolean = false>(
  options: Options<GetTagUsageCountData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetTagUsageCountResponse,
    GetTagUsageCountError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/tags/{id}/usage",
  });
};

export const createRuleExecutions = <ThrowOnError extends boolean = false>(
  options: Options<CreateRuleExecutionsData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    CreateRuleExecutionsResponse,
    CreateRuleExecutionsError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/rules/executions",
  });
};

export const importRuleConfiguration = <ThrowOnError extends boolean = false>(
  options: Options<ImportRuleConfigurationData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    ImportRuleConfigurationResponse,
    ImportRuleConfigurationError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/rules/configuration/{formTemplateId}/import",
  });
};

export const exportRuleConfiguration = <ThrowOnError extends boolean = false>(
  options: Options<ExportRuleConfigurationData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    ExportRuleConfigurationResponse,
    ExportRuleConfigurationError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/rules/configuration/{formTemplateId}/export",
  });
};

export const createFormTemplate = <ThrowOnError extends boolean = false>(
  options: Options<CreateFormTemplateData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    CreateFormTemplateResponse,
    CreateFormTemplateError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/form-templates/",
  });
};

export const getEligibleFormTemplatesForApplicant = <
  ThrowOnError extends boolean = false
>(
  options: Options<GetEligibleFormTemplatesForApplicantData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetEligibleFormTemplatesForApplicantResponse,
    GetEligibleFormTemplatesForApplicantError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/form-templates/eligible",
  });
};

export const listFormTemplatesSettings = <ThrowOnError extends boolean = false>(
  options: Options<ListFormTemplatesSettingsData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    ListFormTemplatesSettingsResponse,
    ListFormTemplatesSettingsError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/form-templates/settings",
  });
};

export const getFormTemplate = <ThrowOnError extends boolean = false>(
  options: Options<GetFormTemplateData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetFormTemplateResponse,
    GetFormTemplateError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/form-templates/{formTemplateId}",
  });
};

export const updateFormTemplate = <ThrowOnError extends boolean = false>(
  options: Options<UpdateFormTemplateData, ThrowOnError>
) => {
  return (options?.client ?? client).put<
    UpdateFormTemplateResponse,
    UpdateFormTemplateError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/form-templates/{formTemplateId}",
  });
};

export const getFormTemplateSettings = <ThrowOnError extends boolean = false>(
  options: Options<GetFormTemplateSettingsData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetFormTemplateSettingsResponse,
    GetFormTemplateSettingsError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/form-templates/{formTemplateId}/settings",
  });
};

export const updateFormTemplateSettings = <
  ThrowOnError extends boolean = false
>(
  options: Options<UpdateFormTemplateSettingsData, ThrowOnError>
) => {
  return (options?.client ?? client).put<
    UpdateFormTemplateSettingsResponse,
    UpdateFormTemplateSettingsError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/form-templates/{formTemplateId}/settings",
  });
};

export const updateFormSchema = <ThrowOnError extends boolean = false>(
  options: Options<UpdateFormSchemaData, ThrowOnError>
) => {
  return (options?.client ?? client).put<
    UpdateFormSchemaResponse,
    UpdateFormSchemaError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/form-templates/{formTemplateId}/schemas",
  });
};

export const diffFormSchema = <ThrowOnError extends boolean = false>(
  options: Options<DiffFormSchemaData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    DiffFormSchemaResponse,
    DiffFormSchemaError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/form-templates/{formTemplateId}/schemas/diff",
  });
};

export const validateFormSchema = <ThrowOnError extends boolean = false>(
  options: Options<ValidateFormSchemaData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    ValidateFormSchemaResponse,
    ValidateFormSchemaError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/form-templates/{formTemplateId}/schemas/validate",
  });
};

export const publishFormSchema = <ThrowOnError extends boolean = false>(
  options: Options<PublishFormSchemaData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    PublishFormSchemaResponse,
    PublishFormSchemaError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/form-templates/{formTemplateId}/schemas/publish",
  });
};

export const exportFormTemplate = <ThrowOnError extends boolean = false>(
  options: Options<ExportFormTemplateData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    ExportFormTemplateResponse,
    ExportFormTemplateError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/form-templates/{formTemplateId}/export",
  });
};

export const importFormTemplateFromJson = <
  ThrowOnError extends boolean = false
>(
  options: Options<ImportFormTemplateFromJsonData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    ImportFormTemplateFromJsonResponse,
    ImportFormTemplateFromJsonError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/form-templates/{formTemplateId}/import",
  });
};

export const importFormTemplateFromOther = <
  ThrowOnError extends boolean = false
>(
  options: Options<ImportFormTemplateFromOtherData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    ImportFormTemplateFromOtherResponse,
    ImportFormTemplateFromOtherError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/form-templates/{formTemplateId}/import/{sourceFormTemplateId}",
  });
};

export const deleteUnpublishedFormSchema = <
  ThrowOnError extends boolean = false
>(
  options: Options<DeleteUnpublishedFormSchemaData, ThrowOnError>
) => {
  return (options?.client ?? client).delete<
    DeleteUnpublishedFormSchemaResponse,
    DeleteUnpublishedFormSchemaError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/form-templates/{formTemplateId}/schemas/unpublished",
  });
};

export const createFormRule = <ThrowOnError extends boolean = false>(
  options: Options<CreateFormRuleData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    CreateFormRuleResponse,
    CreateFormRuleError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/form-templates/{formTemplateId}/form-rules/",
  });
};

export const getFormRule = <ThrowOnError extends boolean = false>(
  options: Options<GetFormRuleData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetFormRuleResponse,
    GetFormRuleError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/form-templates/{formTemplateId}/form-rules/{id}",
  });
};

export const updateFormRule = <ThrowOnError extends boolean = false>(
  options: Options<UpdateFormRuleData, ThrowOnError>
) => {
  return (options?.client ?? client).put<
    UpdateFormRuleResponse,
    UpdateFormRuleError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/form-templates/{formTemplateId}/form-rules/{id}",
  });
};

export const deleteFormRule = <ThrowOnError extends boolean = false>(
  options: Options<DeleteFormRuleData, ThrowOnError>
) => {
  return (options?.client ?? client).delete<
    DeleteFormRuleResponse,
    DeleteFormRuleError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/form-templates/{formTemplateId}/form-rules/{id}",
  });
};

export const updateFormRuleActiveStatus = <
  ThrowOnError extends boolean = false
>(
  options: Options<UpdateFormRuleActiveStatusData, ThrowOnError>
) => {
  return (options?.client ?? client).put<
    UpdateFormRuleActiveStatusResponse,
    UpdateFormRuleActiveStatusError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/form-templates/{formTemplateId}/form-rules/{id}/active",
  });
};

export const exportMessageTemplates = <ThrowOnError extends boolean = false>(
  options: Options<ExportMessageTemplatesData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    ExportMessageTemplatesResponse,
    ExportMessageTemplatesError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/form-templates/{formTemplateId}/message-templates/export",
  });
};

export const importMessageTemplates = <ThrowOnError extends boolean = false>(
  options: Options<ImportMessageTemplatesData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    ImportMessageTemplatesResponse,
    ImportMessageTemplatesError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/form-templates/{formTemplateId}/message-templates/import",
  });
};

export const importMessageTemplatesFromOther = <
  ThrowOnError extends boolean = false
>(
  options: Options<ImportMessageTemplatesFromOtherData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    ImportMessageTemplatesFromOtherResponse,
    ImportMessageTemplatesFromOtherError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/form-templates/{formTemplateId}/message-templates/import/{sourceFormTemplateId}",
  });
};

export const exportSchoolsAndGradesForEnrollmentPeriod = <
  ThrowOnError extends boolean = false
>(
  options: Options<ExportSchoolsAndGradesForEnrollmentPeriodData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    ExportSchoolsAndGradesForEnrollmentPeriodResponse,
    ExportSchoolsAndGradesForEnrollmentPeriodError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/enrollment-periods/{enrollmentPeriodId}/schools/export",
  });
};

export const importSchoolsAndGradesForEnrollmentPeriod = <
  ThrowOnError extends boolean = false
>(
  options: Options<ImportSchoolsAndGradesForEnrollmentPeriodData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    ImportSchoolsAndGradesForEnrollmentPeriodResponse,
    ImportSchoolsAndGradesForEnrollmentPeriodError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/enrollment-periods/{enrollmentPeriodId}/schools/import",
  });
};

export const importSchoolsAndGradesFromOthersForEnrollmentPeriod = <
  ThrowOnError extends boolean = false
>(
  options: Options<
    ImportSchoolsAndGradesFromOthersForEnrollmentPeriodData,
    ThrowOnError
  >
) => {
  return (options?.client ?? client).post<
    ImportSchoolsAndGradesFromOthersForEnrollmentPeriodResponse,
    ImportSchoolsAndGradesFromOthersForEnrollmentPeriodError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/enrollment-periods/{enrollmentPeriodId}/schools/import/{sourceEnrollmentPeriodId}",
  });
};

export const exportSchoolBoundaryConnections = <
  ThrowOnError extends boolean = false
>(
  options: Options<ExportSchoolBoundaryConnectionsData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    ExportSchoolBoundaryConnectionsResponse,
    ExportSchoolBoundaryConnectionsError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/enrollment-periods/{enrollmentPeriodId}/schools/boundary-connections/export",
  });
};

export const importSchoolBoundaryConnections = <
  ThrowOnError extends boolean = false
>(
  options: Options<ImportSchoolBoundaryConnectionsData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    ImportSchoolBoundaryConnectionsResponse,
    ImportSchoolBoundaryConnectionsError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/enrollment-periods/{enrollmentPeriodId}/schools/boundary-connections/import",
  });
};

export const importBoundaryConnectionsFromEnrollmentPeriod = <
  ThrowOnError extends boolean = false
>(
  options: Options<
    ImportBoundaryConnectionsFromEnrollmentPeriodData,
    ThrowOnError
  >
) => {
  return (options?.client ?? client).post<
    ImportBoundaryConnectionsFromEnrollmentPeriodResponse,
    ImportBoundaryConnectionsFromEnrollmentPeriodError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/enrollment-periods/{enrollmentPeriodId}/schools/boundary-connections/fromExisting/{sourceEnrollmentPeriodId}",
  });
};

export const getOfferingCategories = <ThrowOnError extends boolean = false>(
  options: Options<GetOfferingCategoriesData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetOfferingCategoriesResponse,
    GetOfferingCategoriesError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/enrollment-periods/{enrollmentPeriodId}/offerings/categories/",
  });
};

export const createOfferingCategories = <ThrowOnError extends boolean = false>(
  options: Options<CreateOfferingCategoriesData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    CreateOfferingCategoriesResponse,
    CreateOfferingCategoriesError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/enrollment-periods/{enrollmentPeriodId}/offerings/categories/",
  });
};

export const updateOfferingCategory = <ThrowOnError extends boolean = false>(
  options: Options<UpdateOfferingCategoryData, ThrowOnError>
) => {
  return (options?.client ?? client).put<
    UpdateOfferingCategoryResponse,
    UpdateOfferingCategoryError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/enrollment-periods/{enrollmentPeriodId}/offerings/categories/{offeringCategoryId}",
  });
};

export const deleteOfferingCategory = <ThrowOnError extends boolean = false>(
  options: Options<DeleteOfferingCategoryData, ThrowOnError>
) => {
  return (options?.client ?? client).delete<
    DeleteOfferingCategoryResponse,
    DeleteOfferingCategoryError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/enrollment-periods/{enrollmentPeriodId}/offerings/categories/{offeringCategoryId}",
  });
};

export const getOfferings = <ThrowOnError extends boolean = false>(
  options: Options<GetOfferingsData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetOfferingsResponse,
    GetOfferingsError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/enrollment-periods/{enrollmentPeriodId}/offerings/",
  });
};

export const createOfferings = <ThrowOnError extends boolean = false>(
  options: Options<CreateOfferingsData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    CreateOfferingsResponse,
    CreateOfferingsError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/enrollment-periods/{enrollmentPeriodId}/offerings/",
  });
};

export const deleteOffering = <ThrowOnError extends boolean = false>(
  options: Options<DeleteOfferingData, ThrowOnError>
) => {
  return (options?.client ?? client).delete<
    DeleteOfferingResponse,
    DeleteOfferingError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/enrollment-periods/{enrollmentPeriodId}/offerings/{offeringId}",
  });
};

export const addOfferingSeatTypes = <ThrowOnError extends boolean = false>(
  options: Options<AddOfferingSeatTypesData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    AddOfferingSeatTypesResponse,
    AddOfferingSeatTypesError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/enrollment-periods/{enrollmentPeriodId}/offerings/{offeringId}/seat-types",
  });
};

export const deleteOfferingSeatType = <ThrowOnError extends boolean = false>(
  options: Options<DeleteOfferingSeatTypeData, ThrowOnError>
) => {
  return (options?.client ?? client).delete<
    DeleteOfferingSeatTypeResponse,
    DeleteOfferingSeatTypeError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/enrollment-periods/{enrollmentPeriodId}/offerings/{offeringId}/seat-types/{seatTypeId}",
  });
};

export const createBoundaryConnections = <ThrowOnError extends boolean = false>(
  options: Options<CreateBoundaryConnectionsData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    CreateBoundaryConnectionsResponse,
    CreateBoundaryConnectionsError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/boundaries/connections/",
  });
};

export const updateBoundaryConnections = <ThrowOnError extends boolean = false>(
  options: Options<UpdateBoundaryConnectionsData, ThrowOnError>
) => {
  return (options?.client ?? client).put<
    UpdateBoundaryConnectionsResponse,
    UpdateBoundaryConnectionsError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/boundaries/connections/",
  });
};

export const deleteBoundaryConnections = <ThrowOnError extends boolean = false>(
  options: Options<DeleteBoundaryConnectionsData, ThrowOnError>
) => {
  return (options?.client ?? client).delete<
    DeleteBoundaryConnectionsResponse,
    DeleteBoundaryConnectionsError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/boundaries/connections/",
  });
};

export const getBoundaryConnectionsBySchoolId = <
  ThrowOnError extends boolean = false
>(
  options: Options<GetBoundaryConnectionsBySchoolIdData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetBoundaryConnectionsBySchoolIdResponse,
    GetBoundaryConnectionsBySchoolIdError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/boundaries/connections/school/{schoolId}/enrollmentPeriod/{enrollmentPeriodId}",
  });
};

export const getBoundaries = <ThrowOnError extends boolean = false>(
  options?: Options<GetBoundariesData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetBoundariesResponse,
    GetBoundariesError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/boundaries/",
  });
};

export const postBoundaries = <ThrowOnError extends boolean = false>(
  options: Options<PostBoundariesData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    PostBoundariesResponse,
    PostBoundariesError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/boundaries/",
  });
};

export const deleteBoundaries = <ThrowOnError extends boolean = false>(
  options: Options<DeleteBoundariesData, ThrowOnError>
) => {
  return (options?.client ?? client).delete<
    DeleteBoundariesResponse,
    DeleteBoundariesError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/boundaries/",
  });
};

export const getBoundariesMetadata = <ThrowOnError extends boolean = false>(
  options: Options<GetBoundariesMetadataData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetBoundariesMetadataResponse,
    GetBoundariesMetadataError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/boundaries/metadata",
  });
};

export const getBoundariesByOrgId = <ThrowOnError extends boolean = false>(
  options: Options<GetBoundariesByOrgIdData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetBoundariesByOrgIdResponse,
    GetBoundariesByOrgIdError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/boundaries/org/{orgId}",
  });
};

export const updateBoundaryById = <ThrowOnError extends boolean = false>(
  options: Options<UpdateBoundaryByIdData, ThrowOnError>
) => {
  return (options?.client ?? client).put<
    UpdateBoundaryByIdResponse,
    UpdateBoundaryByIdError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/boundaries/{id}",
  });
};

export const exportBoundaryGeoJson = <ThrowOnError extends boolean = false>(
  options: Options<ExportBoundaryGeoJsonData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    ExportBoundaryGeoJsonResponse,
    ExportBoundaryGeoJsonError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/boundaries/{id}/geojson",
  });
};

export const exportBoundariesByOrgGeoJson = <
  ThrowOnError extends boolean = false
>(
  options: Options<ExportBoundariesByOrgGeoJsonData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    ExportBoundariesByOrgGeoJsonResponse,
    ExportBoundariesByOrgGeoJsonError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/boundaries/org/{orgId}/geojson",
  });
};

export const getBoundaryMapByFormId = <ThrowOnError extends boolean = false>(
  options: Options<GetBoundaryMapByFormIdData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetBoundaryMapByFormIdResponse,
    GetBoundaryMapByFormIdError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/boundaries/map/form/{formId}",
  });
};

export const getBoundaryMapByEnrollmentPeriodId = <
  ThrowOnError extends boolean = false
>(
  options: Options<GetBoundaryMapByEnrollmentPeriodIdData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetBoundaryMapByEnrollmentPeriodIdResponse,
    GetBoundaryMapByEnrollmentPeriodIdError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/boundaries/map/enrollment-period/{enrollmentPeriodId}",
  });
};

export const getBoundaryMapByFormIdOptimized = <
  ThrowOnError extends boolean = false
>(
  options: Options<GetBoundaryMapByFormIdOptimizedData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetBoundaryMapByFormIdOptimizedResponse,
    GetBoundaryMapByFormIdOptimizedError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/boundaries/map/form/{formId}/optimized",
  });
};

export const getBoundaryMapByEnrollmentPeriodIdOptimized = <
  ThrowOnError extends boolean = false
>(
  options: Options<
    GetBoundaryMapByEnrollmentPeriodIdOptimizedData,
    ThrowOnError
  >
) => {
  return (options?.client ?? client).get<
    GetBoundaryMapByEnrollmentPeriodIdOptimizedResponse,
    GetBoundaryMapByEnrollmentPeriodIdOptimizedError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/boundaries/map/enrollment-period/{enrollmentPeriodId}/optimized",
  });
};

export const exportCapacitiesBySchoolAndEnrollmentPeriod = <
  ThrowOnError extends boolean = false
>(
  options: Options<
    ExportCapacitiesBySchoolAndEnrollmentPeriodData,
    ThrowOnError
  >
) => {
  return (options?.client ?? client).post<
    ExportCapacitiesBySchoolAndEnrollmentPeriodResponse,
    ExportCapacitiesBySchoolAndEnrollmentPeriodError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/capacities/enrollment-period/{enrollmentPeriodId}/school/{schoolId}/export",
  });
};

export const getCapacitiesBySchoolAndEnrollmentPeriod = <
  ThrowOnError extends boolean = false
>(
  options: Options<GetCapacitiesBySchoolAndEnrollmentPeriodData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetCapacitiesBySchoolAndEnrollmentPeriodResponse,
    GetCapacitiesBySchoolAndEnrollmentPeriodError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/capacities/enrollment-period/{enrollmentPeriodId}/school/{schoolId}",
  });
};

export const listCapacitiesBySchoolAndEnrollmentPeriod = <
  ThrowOnError extends boolean = false
>(
  options: Options<ListCapacitiesBySchoolAndEnrollmentPeriodData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    ListCapacitiesBySchoolAndEnrollmentPeriodResponse,
    ListCapacitiesBySchoolAndEnrollmentPeriodError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/capacities/enrollment-period/{enrollmentPeriodId}/school/{schoolId}/list",
  });
};

export const listCapacitiesByEnrollmentPeriod = <
  ThrowOnError extends boolean = false
>(
  options: Options<ListCapacitiesByEnrollmentPeriodData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    ListCapacitiesByEnrollmentPeriodResponse,
    ListCapacitiesByEnrollmentPeriodError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/capacities/enrollment-period/{enrollmentPeriodId}/list",
  });
};

export const exportCapacitiesByEnrollmentPeriod = <
  ThrowOnError extends boolean = false
>(
  options: Options<ExportCapacitiesByEnrollmentPeriodData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    ExportCapacitiesByEnrollmentPeriodResponse,
    ExportCapacitiesByEnrollmentPeriodError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/capacities/enrollment-period/{enrollmentPeriodId}/export",
  });
};

export const importCapacitiesByEnrollmentPeriod = <
  ThrowOnError extends boolean = false
>(
  options: Options<ImportCapacitiesByEnrollmentPeriodData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    ImportCapacitiesByEnrollmentPeriodResponse,
    ImportCapacitiesByEnrollmentPeriodError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/capacities/enrollment-period/{enrollmentPeriodId}/import",
  });
};

export const getCapacitiesConfigByEnrollmentPeriod = <
  ThrowOnError extends boolean = false
>(
  options: Options<GetCapacitiesConfigByEnrollmentPeriodData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetCapacitiesConfigByEnrollmentPeriodResponse,
    GetCapacitiesConfigByEnrollmentPeriodError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/capacities/enrollment-period/{enrollmentPeriodId}/config",
  });
};

export const updateCapacitiesConfigByEnrollmentPeriod = <
  ThrowOnError extends boolean = false
>(
  options: Options<UpdateCapacitiesConfigByEnrollmentPeriodData, ThrowOnError>
) => {
  return (options?.client ?? client).put<
    UpdateCapacitiesConfigByEnrollmentPeriodResponse,
    UpdateCapacitiesConfigByEnrollmentPeriodError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/capacities/enrollment-period/{enrollmentPeriodId}/config",
  });
};

export const updateCapacitiesByEnrollmentPeriod = <
  ThrowOnError extends boolean = false
>(
  options: Options<UpdateCapacitiesByEnrollmentPeriodData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    UpdateCapacitiesByEnrollmentPeriodResponse,
    UpdateCapacitiesByEnrollmentPeriodError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/capacities/enrollment-period/{enrollmentPeriodId}",
  });
};

export const getCapacitySummaryByEnrollmentPeriod = <
  ThrowOnError extends boolean = false
>(
  options: Options<GetCapacitySummaryByEnrollmentPeriodData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetCapacitySummaryByEnrollmentPeriodResponse,
    GetCapacitySummaryByEnrollmentPeriodError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/capacities/enrollment-period/{enrollmentPeriodId}",
  });
};

export const getCapacitiesHistory = <ThrowOnError extends boolean = false>(
  options: Options<GetCapacitiesHistoryData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetCapacitiesHistoryResponse,
    GetCapacitiesHistoryError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/capacities/enrollment-period/{enrollmentPeriodId}/history",
  });
};

export const getCapacitiesHistoryDetail = <
  ThrowOnError extends boolean = false
>(
  options: Options<GetCapacitiesHistoryDetailData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetCapacitiesHistoryDetailResponse,
    GetCapacitiesHistoryDetailError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/capacities/enrollment-period/{enrollmentPeriodId}/history/{transactionId}",
  });
};

export const getSchools = <ThrowOnError extends boolean = false>(
  options: Options<GetSchoolsData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetSchoolsResponse,
    GetSchoolsError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/schools/",
  });
};

export const getSchoolsByEnrollmentPeriod = <
  ThrowOnError extends boolean = false
>(
  options: Options<GetSchoolsByEnrollmentPeriodData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetSchoolsByEnrollmentPeriodResponse,
    GetSchoolsByEnrollmentPeriodError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/schools/enrollmentPeriod/{enrollmentPeriodId}",
  });
};

export const getDashboardFormStatus = <ThrowOnError extends boolean = false>(
  options: Options<GetDashboardFormStatusData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetDashboardFormStatusResponse,
    GetDashboardFormStatusError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/dashboard/form-status/{formTemplateId}",
  });
};

export const getDashboardFormSubstatus = <ThrowOnError extends boolean = false>(
  options: Options<GetDashboardFormSubstatusData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetDashboardFormSubstatusResponse,
    GetDashboardFormSubstatusError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/dashboard/form-substatus/{formTemplateId}",
  });
};

export const getDashboardFormSchoolGradeRank = <
  ThrowOnError extends boolean = false
>(
  options: Options<GetDashboardFormSchoolGradeRankData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetDashboardFormSchoolGradeRankResponse,
    GetDashboardFormSchoolGradeRankError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/dashboard/form-school-grade-rank/{formTemplateId}",
  });
};

export const getDashboardFormResponsesOverTime = <
  ThrowOnError extends boolean = false
>(
  options: Options<GetDashboardFormResponsesOverTimeData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetDashboardFormResponsesOverTimeResponse,
    GetDashboardFormResponsesOverTimeError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/dashboard/form-responses-over-time/{formTemplateId}",
  });
};

export const getAdminGreeting = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminGreetingData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetAdminGreetingResponse,
    GetAdminGreetingError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/dashboard/admin-greeting/{organizationId}",
  });
};

export const getGradeConfigByEnrollmentPeriod = <
  ThrowOnError extends boolean = false
>(
  options: Options<GetGradeConfigByEnrollmentPeriodData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetGradeConfigByEnrollmentPeriodResponse,
    GetGradeConfigByEnrollmentPeriodError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/grades/grade-config/enrollment-period/{enrollmentPeriodId}",
  });
};

export const searchApplicants = <ThrowOnError extends boolean = false>(
  options: Options<SearchApplicantsData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    SearchApplicantsResponse2,
    SearchApplicantsError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/person/search",
  });
};

export const searchApplicantDuplicates = <ThrowOnError extends boolean = false>(
  options: Options<SearchApplicantDuplicatesData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    SearchApplicantDuplicatesResponse2,
    SearchApplicantDuplicatesError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/person/duplicates",
  });
};

export const searchParents = <ThrowOnError extends boolean = false>(
  options: Options<SearchParentsData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    SearchParentsResponse2,
    SearchParentsError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/person/parents",
  });
};

export const createFamily = <ThrowOnError extends boolean = false>(
  options: Options<CreateFamilyData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    CreateFamilyResponse2,
    CreateFamilyError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/person/family",
  });
};

export const createLoginPrefillToken = <ThrowOnError extends boolean = false>(
  options: Options<CreateLoginPrefillTokenData, ThrowOnError>
) => {
  return (options?.client ?? client).put<
    CreateLoginPrefillTokenResponse,
    CreateLoginPrefillTokenError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/person/{personId}/login_prefill",
  });
};

export const listMatchRuns = <ThrowOnError extends boolean = false>(
  options: Options<ListMatchRunsData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    ListMatchRunsResponse2,
    ListMatchRunsError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/match/runs/",
  });
};

export const createMatchRun = <ThrowOnError extends boolean = false>(
  options: Options<CreateMatchRunData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    CreateMatchRunResponse2,
    CreateMatchRunError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/match/runs/",
  });
};

export const getMatchRunDetails = <ThrowOnError extends boolean = false>(
  options: Options<GetMatchRunDetailsData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetMatchRunDetailsResponse2,
    GetMatchRunDetailsError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/match/runs/{matchRunId}/details",
  });
};

export const getMatchRun = <ThrowOnError extends boolean = false>(
  options: Options<GetMatchRunData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetMatchRunResponse2,
    GetMatchRunError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/match/runs/{matchRunId}",
  });
};

export const publishMatchRun = <ThrowOnError extends boolean = false>(
  options: Options<PublishMatchRunData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    PublishMatchRunResponse,
    PublishMatchRunError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/match/runs/{matchRunId}/publish",
  });
};

export const getFormAlertsByFormId = <ThrowOnError extends boolean = false>(
  options: Options<GetFormAlertsByFormIdData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetFormAlertsByFormIdResponse,
    GetFormAlertsByFormIdError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/form-alerts/forms/{id}",
  });
};

export const archiveTeamMembers = <ThrowOnError extends boolean = false>(
  options: Options<ArchiveTeamMembersData, ThrowOnError>
) => {
  return (options?.client ?? client).patch<
    ArchiveTeamMembersResponse,
    ArchiveTeamMembersError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/team-members/archive",
  });
};

export const resetTeamMemberMfa = <ThrowOnError extends boolean = false>(
  options: Options<ResetTeamMemberMfaData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    ResetTeamMemberMfaResponse,
    ResetTeamMemberMfaError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/team-members/{personId}/mfa-reset",
  });
};

export const createTeamMember = <ThrowOnError extends boolean = false>(
  options: Options<CreateTeamMemberData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    CreateTeamMemberResponse,
    CreateTeamMemberError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/team-members/",
  });
};

export const editTeamMember = <ThrowOnError extends boolean = false>(
  options: Options<EditTeamMemberData, ThrowOnError>
) => {
  return (options?.client ?? client).put<
    EditTeamMemberResponse,
    EditTeamMemberError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/team-members/{personId}",
  });
};

export const sendPasswordReset = <ThrowOnError extends boolean = false>(
  options: Options<SendPasswordResetData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    SendPasswordResetResponse,
    SendPasswordResetError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/team-members/{personId}/password-reset",
  });
};

export const listUserGroups = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    ListUserGroupsResponse,
    ListUserGroupsError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/teams/user-groups",
  });
};

export const listTeams = <ThrowOnError extends boolean = false>(
  options: Options<ListTeamsData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    ListTeamsResponse,
    ListTeamsError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/teams/",
  });
};

export const listApiCredentials = <ThrowOnError extends boolean = false>(
  options: Options<ListApiCredentialsData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    ListApiCredentialsResponse,
    ListApiCredentialsError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/api-credentials/",
  });
};

export const createApiCredential = <ThrowOnError extends boolean = false>(
  options: Options<CreateApiCredentialData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    CreateApiCredentialResponse,
    CreateApiCredentialError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/api-credentials/",
  });
};

export const getApiCredential = <ThrowOnError extends boolean = false>(
  options: Options<GetApiCredentialData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetApiCredentialResponse,
    GetApiCredentialError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/api-credentials/{clientId}",
  });
};

export const updateApiCredential = <ThrowOnError extends boolean = false>(
  options: Options<UpdateApiCredentialData, ThrowOnError>
) => {
  return (options?.client ?? client).put<
    UpdateApiCredentialResponse,
    UpdateApiCredentialError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/api-credentials/{clientId}",
  });
};

export const deleteApiCredential = <ThrowOnError extends boolean = false>(
  options: Options<DeleteApiCredentialData, ThrowOnError>
) => {
  return (options?.client ?? client).delete<
    DeleteApiCredentialResponse,
    DeleteApiCredentialError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/api-credentials/{clientId}",
  });
};

export const rotateApiCredentialSecret = <ThrowOnError extends boolean = false>(
  options: Options<RotateApiCredentialSecretData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    RotateApiCredentialSecretResponse,
    RotateApiCredentialSecretError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/api-credentials/{clientId}/rotate-secret",
  });
};

export const createOrganization = <ThrowOnError extends boolean = false>(
  options: Options<CreateOrganizationData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    CreateOrganizationResponse,
    CreateOrganizationError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/organizations/",
  });
};

export const generateUploadUrl = <ThrowOnError extends boolean = false>(
  options: Options<GenerateUploadUrlData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    GenerateUploadUrlResponse,
    GenerateUploadUrlError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/organizations/generateUploadUrl",
  });
};

export const generateBannerImageUploadUrl = <
  ThrowOnError extends boolean = false
>(
  options: Options<GenerateBannerImageUploadUrlData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    GenerateBannerImageUploadUrlResponse,
    GenerateBannerImageUploadUrlError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/organizations/{organizationId}/generateBannerImageUploadUrl",
  });
};

export const getOrganizationConfig = <ThrowOnError extends boolean = false>(
  options: Options<GetOrganizationConfigData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetOrganizationConfigResponse,
    GetOrganizationConfigError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/organizations/{organizationId}/configs/{configType}",
  });
};

export const updateOrganizationConfig = <ThrowOnError extends boolean = false>(
  options: Options<UpdateOrganizationConfigData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    UpdateOrganizationConfigResponse,
    UpdateOrganizationConfigError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/organizations/{organizationId}/configs",
  });
};

export const connectStripeAccount = <ThrowOnError extends boolean = false>(
  options: Options<ConnectStripeAccountData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    ConnectStripeAccountResponse,
    ConnectStripeAccountError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/organizations/{organizationId}/stripe/connect-account",
  });
};

export const disconnectStripeAccount = <ThrowOnError extends boolean = false>(
  options: Options<DisconnectStripeAccountData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    DisconnectStripeAccountResponse,
    DisconnectStripeAccountError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/organizations/{organizationId}/stripe/disconnect-account",
  });
};

export const listPaymentTemplates = <ThrowOnError extends boolean = false>(
  options: Options<ListPaymentTemplatesData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    ListPaymentTemplatesResponse2,
    ListPaymentTemplatesError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/payments/templates",
  });
};

export const getPaymentTemplate = <ThrowOnError extends boolean = false>(
  options: Options<GetPaymentTemplateData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetPaymentTemplateResponse,
    GetPaymentTemplateError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/payments/templates/{templateId}",
  });
};

export const updatePaymentTemplate = <ThrowOnError extends boolean = false>(
  options: Options<UpdatePaymentTemplateData, ThrowOnError>
) => {
  return (options?.client ?? client).patch<
    UpdatePaymentTemplateResponse,
    UpdatePaymentTemplateError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/payments/templates/{templateId}",
  });
};

export const deletePaymentTemplate = <ThrowOnError extends boolean = false>(
  options: Options<DeletePaymentTemplateData, ThrowOnError>
) => {
  return (options?.client ?? client).delete<
    DeletePaymentTemplateResponse2,
    DeletePaymentTemplateError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/payments/templates/{templateId}",
  });
};

export const createPaymentTemplate = <ThrowOnError extends boolean = false>(
  options: Options<CreatePaymentTemplateData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    CreatePaymentTemplateResponse,
    CreatePaymentTemplateError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/payments/createTemplate",
  });
};

export const listPayments = <ThrowOnError extends boolean = false>(
  options: Options<ListPaymentsData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    ListPaymentsResponse2,
    ListPaymentsError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/payments/{organizationId}",
  });
};

export const getAdminPaymentReceipt = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminPaymentReceiptData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetAdminPaymentReceiptResponse,
    GetAdminPaymentReceiptError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/payments/payments/{paymentId}/receipt",
  });
};

export const cancelPayment = <ThrowOnError extends boolean = false>(
  options: Options<CancelPaymentData, ThrowOnError>
) => {
  return (options?.client ?? client).put<
    CancelPaymentResponse2,
    CancelPaymentError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/payments/payments/{paymentId}/cancel",
  });
};

export const createPayments = <ThrowOnError extends boolean = false>(
  options: Options<CreatePaymentsData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    CreatePaymentsResponse2,
    CreatePaymentsError,
    ThrowOnError
  >({
    ...options,
    url: "/admin/payments/createPayments",
  });
};

export const getAdmissionsForMe = <ThrowOnError extends boolean = false>(
  options: Options<GetAdmissionsForMeData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetAdmissionsForMeResponse2,
    GetAdmissionsForMeError,
    ThrowOnError
  >({
    ...options,
    url: "/me/forms/{formId}/admissions/",
  });
};

export const withdrawFromWaitlist = <ThrowOnError extends boolean = false>(
  options: Options<WithdrawFromWaitlistData, ThrowOnError>
) => {
  return (options?.client ?? client).put<
    WithdrawFromWaitlistResponse,
    WithdrawFromWaitlistError,
    ThrowOnError
  >({
    ...options,
    url: "/me/forms/{formId}/waitlists/withdraw",
  });
};

export const getOffersForMe = <ThrowOnError extends boolean = false>(
  options: Options<GetOffersForMeData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetOffersForMeResponse,
    GetOffersForMeError,
    ThrowOnError
  >({
    ...options,
    url: "/me/forms/{formId}/offers/",
  });
};

export const acceptOffer = <ThrowOnError extends boolean = false>(
  options: Options<AcceptOfferData, ThrowOnError>
) => {
  return (options?.client ?? client).put<
    AcceptOfferResponse,
    AcceptOfferError,
    ThrowOnError
  >({
    ...options,
    url: "/me/forms/{formId}/offers/accept",
  });
};

export const declineOffer = <ThrowOnError extends boolean = false>(
  options: Options<DeclineOfferData, ThrowOnError>
) => {
  return (options?.client ?? client).put<
    DeclineOfferResponse,
    DeclineOfferError,
    ThrowOnError
  >({
    ...options,
    url: "/me/forms/{formId}/offers/decline",
  });
};

export const getAnswersForMe = <ThrowOnError extends boolean = false>(
  options: Options<GetAnswersForMeData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetAnswersForMeResponse,
    GetAnswersForMeError,
    ThrowOnError
  >({
    ...options,
    url: "/me/forms/{formId}/answers/",
  });
};

export const putAnswersForMe = <ThrowOnError extends boolean = false>(
  options: Options<PutAnswersForMeData, ThrowOnError>
) => {
  return (options?.client ?? client).put<
    PutAnswersForMeResponse,
    PutAnswersForMeError,
    ThrowOnError
  >({
    ...options,
    url: "/me/forms/{formId}/answers/",
  });
};

export const putAnswerForMe = <ThrowOnError extends boolean = false>(
  options: Options<PutAnswerForMeData, ThrowOnError>
) => {
  return (options?.client ?? client).put<
    PutAnswerForMeResponse,
    PutAnswerForMeError,
    ThrowOnError
  >({
    ...options,
    url: "/me/forms/{formId}/answers/{questionId}",
  });
};

export const clearAnswerForMe = <ThrowOnError extends boolean = false>(
  options: Options<ClearAnswerForMeData, ThrowOnError>
) => {
  return (options?.client ?? client).delete<
    ClearAnswerForMeResponse,
    ClearAnswerForMeError,
    ThrowOnError
  >({
    ...options,
    url: "/me/forms/{formId}/answers/{questionId}",
  });
};

export const resetFormForMe = <ThrowOnError extends boolean = false>(
  options: Options<ResetFormForMeData, ThrowOnError>
) => {
  return (options?.client ?? client).put<
    ResetFormForMeResponse,
    ResetFormForMeError,
    ThrowOnError
  >({
    ...options,
    url: "/me/forms/{formId}/reset",
  });
};

export const submitFormForMe = <ThrowOnError extends boolean = false>(
  options: Options<SubmitFormForMeData, ThrowOnError>
) => {
  return (options?.client ?? client).put<
    SubmitFormForMeResponse,
    SubmitFormForMeError,
    ThrowOnError
  >({
    ...options,
    url: "/me/forms/{formId}/submit",
  });
};

export const deleteFormForMe = <ThrowOnError extends boolean = false>(
  options: Options<DeleteFormForMeData, ThrowOnError>
) => {
  return (options?.client ?? client).put<
    DeleteFormForMeResponse,
    DeleteFormForMeError,
    ThrowOnError
  >({
    ...options,
    url: "/me/forms/{formId}/delete",
  });
};

export const getEligibleFormTemplatesForMe = <
  ThrowOnError extends boolean = false
>(
  options: Options<GetEligibleFormTemplatesForMeData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetEligibleFormTemplatesForMeResponse,
    GetEligibleFormTemplatesForMeError,
    ThrowOnError
  >({
    ...options,
    url: "/me/form-templates/eligible",
  });
};

export const getFormTemplateSettingsForMe = <
  ThrowOnError extends boolean = false
>(
  options: Options<GetFormTemplateSettingsForMeData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetFormTemplateSettingsForMeResponse,
    GetFormTemplateSettingsForMeError,
    ThrowOnError
  >({
    ...options,
    url: "/me/form-templates/{formTemplateId}/settings",
  });
};

export const parentGetBoundaryMapByFormId = <
  ThrowOnError extends boolean = false
>(
  options: Options<ParentGetBoundaryMapByFormIdData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    ParentGetBoundaryMapByFormIdResponse,
    ParentGetBoundaryMapByFormIdError,
    ThrowOnError
  >({
    ...options,
    url: "/me/boundaries/form/{formId}",
  });
};

export const parentGetBoundaryMapByEnrollmentPeriodId = <
  ThrowOnError extends boolean = false
>(
  options: Options<ParentGetBoundaryMapByEnrollmentPeriodIdData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    ParentGetBoundaryMapByEnrollmentPeriodIdResponse,
    ParentGetBoundaryMapByEnrollmentPeriodIdError,
    ThrowOnError
  >({
    ...options,
    url: "/me/boundaries/enrollment-period/{enrollmentPeriodId}",
  });
};

export const parentGetBoundaryMapByFormIdOptimized = <
  ThrowOnError extends boolean = false
>(
  options: Options<ParentGetBoundaryMapByFormIdOptimizedData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    ParentGetBoundaryMapByFormIdOptimizedResponse,
    ParentGetBoundaryMapByFormIdOptimizedError,
    ThrowOnError
  >({
    ...options,
    url: "/me/boundaries/form/{formId}/optimized",
  });
};

export const parentGetBoundaryMapByEnrollmentPeriodIdOptimized = <
  ThrowOnError extends boolean = false
>(
  options: Options<
    ParentGetBoundaryMapByEnrollmentPeriodIdOptimizedData,
    ThrowOnError
  >
) => {
  return (options?.client ?? client).get<
    ParentGetBoundaryMapByEnrollmentPeriodIdOptimizedResponse,
    ParentGetBoundaryMapByEnrollmentPeriodIdOptimizedError,
    ThrowOnError
  >({
    ...options,
    url: "/me/boundaries/enrollment-period/{enrollmentPeriodId}/optimized",
  });
};

export const createRuleExecutionsForMe = <ThrowOnError extends boolean = false>(
  options: Options<CreateRuleExecutionsForMeData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    CreateRuleExecutionsForMeResponse,
    CreateRuleExecutionsForMeError,
    ThrowOnError
  >({
    ...options,
    url: "/me/rules/executions",
  });
};

export const resendVerificationEmail = <ThrowOnError extends boolean = false>(
  options: Options<ResendVerificationEmailData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    ResendVerificationEmailResponse,
    ResendVerificationEmailError,
    ThrowOnError
  >({
    ...options,
    url: "/me/accounts/resend-verification-email",
  });
};

export const getPaymentsForMe = <ThrowOnError extends boolean = false>(
  options: Options<GetPaymentsForMeData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetPaymentsForMeResponse,
    GetPaymentsForMeError,
    ThrowOnError
  >({
    ...options,
    url: "/me/payments/",
  });
};

export const getPaymentReceipt = <ThrowOnError extends boolean = false>(
  options?: Options<GetPaymentReceiptData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetPaymentReceiptResponse,
    GetPaymentReceiptError,
    ThrowOnError
  >({
    ...options,
    url: "/me/payments/receipt",
  });
};

export const checkout = <ThrowOnError extends boolean = false>(
  options: Options<CheckoutData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    CheckoutResponse,
    CheckoutError,
    ThrowOnError
  >({
    ...options,
    url: "/me/payments/checkout",
  });
};
